var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.4 4.39999H19.6C20.645 4.39999 21.5 5.25499 21.5 6.29999V17.7C21.5 18.745 20.645 19.6 19.6 19.6H4.4C3.355 19.6 2.5 18.745 2.5 17.7L2.5095 6.29999C2.5095 5.25499 3.355 4.39999 4.4 4.39999ZM12 12.95L19.6 8.19999V6.29999L12 11.05L4.4 6.29999V8.19999L12 12.95Z"}));
}

MailInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = MailInline;

MailInline.default = MailInline;
